<template>
  <div class="col-2">
    <div class="card">
      <div class="card-body py-2 px-3 bg-white d-flex flex-column">
        <p class="mb-0 d-flex justify-content-between border-bottom">
          <span class="font-weight-bold">{{ idOrLogin }}</span>
        </p>
        <div class="form-row">
          <div class="col-6">
            <p class="small mb-0">
              Description: <span :class="{'font-weight-bold':descriptionRuleCount > 0}">{{ descriptionRuleCount }}</span>
            </p>
            <p class="small mb-0">
              Image: <span :class="{'font-weight-bold':imageRuleCount > 0}">{{ imageRuleCount }}</span>
            </p>
            <p class="small mb-0">
              Feature: <span :class="{'font-weight-bold':featureRuleCount > 0}">{{ featureRuleCount }}</span>
            </p>
          </div>
          <div class="col-6">
            <p class="small mb-0">
              Location: <span :class="{'font-weight-bold':locationRuleCount > 0}">{{ locationRuleCount }}</span>
            </p>
            <p class="small mb-0">
              Media: <span :class="{'font-weight-bold':mediaRuleCount > 0}">{{ mediaRuleCount }}</span>
            </p>
            <p class="small mb-0">
              Attribute: <span :class="{'font-weight-bold':attributeRuleCount > 0}">{{ attributeRuleCount }}</span>
            </p>
          </div>
        </div>
        <p class="mb-0 text-muted small d-flex justify-content-between border-top mt-2">
          <span>{{ $props.item.createdBy }}</span> <span>({{ createdAt }})</span>
          <!-- <router-link
            v-if="isPropertyScope"
            :to="link"
          >
            View
          </router-link> -->
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {
    RuleTypeAttribute,
    RuleTypeDescription,
    RuleTypeImage,
    RuleTypeFeature,
    RuleTypeLocation,
    RuleTypeMedia
} from './consts';

export default {
    computed: {
        idOrLogin() {
            if ( this.$props.item.login.length > 0 ) {
                return this.$props.item.login;
            }
            return this.$props.item.propertyID;
        },
        link() {
            return `property-quality-control/${this.$props.item.propertyID}`;
        },
        isPropertyScope() {
            return this.$props.item.propertyID !== 0;
        },
        rules() {
            return this.$props.item.rules || [];
        },
        descriptionRuleCount() {
            return this.rules.filter( r=> r.type === RuleTypeDescription ).length;
        },
        imageRuleCount() {
            return this.rules.filter( r=> r.type === RuleTypeImage ).length;
        },
        featureRuleCount() {
            return this.rules.filter( r=> r.type === RuleTypeFeature ).length;
        },
        locationRuleCount() {
            return this.rules.filter( r=> r.type === RuleTypeLocation ).length;
        },
        mediaRuleCount() {
            return this.rules.filter( r=> r.type === RuleTypeMedia ).length;
        },
        attributeRuleCount() {
            return this.rules.filter( r=> r.type === RuleTypeAttribute ).length;
        },
        createdAt() {
            return moment( this.$props.item.createdAt ).format( 'DD/MM' );
        }
    },
    props: {
        item: {
            type: Object,
            required: true
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/property-qc/RuleSearchItem.vue